// extracted by mini-css-extract-plugin
module.exports = {"message":"Confirm_message__13oZL","buttons":"Confirm_buttons__395hR"};